<div class="page-head">
  <div>
    <p class="eyebrow">การเงิน</p>
    <h1>รายการชำระเงิน</h1>
    <p>ติดตามการตรวจ อนุมัติ และการขำระเงิน</p>
  </div>
<!--   <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 active:scale-[0.98]"
  >
    <lucide-icon name="Plus" [size]="17" /> เพิ่มการชำระ
  </button> -->
</div>

<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #paymentsTable
    [value]="payments()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="['bookingCode', 'customerName', 'status']"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    styleClass="payments-table"
    [tableStyle]="{ 'min-width': '850px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 lg:flex-row lg:items-center">
        <label class="relative block w-full lg:max-w-md">
          <lucide-icon name="Search" [size]="17" class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400" />
          <input pInputText
            #search
            class="h-11 w-full pr-3 text-sm placeholder:text-slate-400" style="padding-left: 2.75rem; border-radius: 0.5rem"
            placeholder="ค้นหา Booking หรือลูกค้า"
            (input)="paymentsTable.filterGlobal(search.value, 'contains')"
          />
        </label>

        <p-select
          class="w-full lg:w-52"
          [options]="statusOptions"
          [(ngModel)]="selectedStatus"
          optionLabel="label"
          optionValue="value"
          placeholder="ทุกสถานะ"
          [showClear]="true"
          (onChange)="paymentsTable.filter($event.value, 'status', 'equals')"
        />

        <p-datepicker
          class="w-full lg:w-52"
          [(ngModel)]="selectedDate"
          dateFormat="dd/mm/yy"
          placeholder="วันที่ชำระ"
          [showIcon]="true"
          [showClear]="true"
          [readonlyInput]="true"
          (onSelect)="paymentsTable.filter(toDateFilter($event), 'paidAt', 'equals')"
          (onClear)="paymentsTable.filter(null, 'paidAt', 'equals')"
          appendTo="body"
        />
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th pSortableColumn="bookingCode">Booking <p-sortIcon field="bookingCode" /></th>
        <th pSortableColumn="customerName">ลูกค้า <p-sortIcon field="customerName" /></th>
        <th pSortableColumn="amount">ยอดชำระ <p-sortIcon field="amount" /></th>
        <th pSortableColumn="paidAt">วันที่ชำระ <p-sortIcon field="paidAt" /></th>
        <th pSortableColumn="status">สถานะ <p-sortIcon field="status" /></th>
        <th class="text-right">ดำเนินการ</th>
      </tr>
    </ng-template>

    <ng-template #body let-row>
      <tr>
        <td><strong>{{ row.bookingCode }}</strong></td>
        <td>{{ row.customerName }}</td>
        <td>{{ row.amount | number: '1.2-2' }} บาท</td>
        <td>{{ row.paidAt | date: 'dd MMM yyyy' }}</td>
        <td><app-status-badge [status]="row.status" /></td>
        <td>
          <div class="flex justify-end gap-2">
            <button
              class="tw-button rounded-lg border border-slate-200 bg-white p-2 text-slate-600 hover:bg-slate-50"
              type="button"
              title="ดูหลักฐาน"
              (click)="openPaymentDetail(row)"
            >
              <lucide-icon name="Eye" [size]="17" />
            </button>
           <!--  @if (row.status === 'WAITING_VERIFY') {
              <button
                class="tw-button inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-700"
                type="button"
                (click)="approvePayment(row)"
              >
                <lucide-icon name="Check" [size]="15" /> ยืนยันยอด
              </button>
            } -->
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr><td colspan="6"><div class="empty"><h3>ไม่พบรายการชำระ</h3><p>ลองเปลี่ยนคำค้นหาหรือตัวกรอง</p></div></td></tr>
    </ng-template>
  </p-table>
</section>

@if (selectedPayment(); as payment) {
  <div class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]" (click)="closePaymentDetail()">
    <section class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl" role="dialog" aria-modal="true" aria-labelledby="payment-detail-title" (click)="$event.stopPropagation()">
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">{{ payment.bookingCode }}</p>
          <h2 id="payment-detail-title" class="m-0 text-xl font-bold text-slate-800">รายละเอียดการชำระเงิน</h2>
          <div class="mt-2"><app-status-badge [status]="payment.status" /></div>
        </div>
        <button type="button" class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50" aria-label="ปิดหน้าต่าง" (click)="closePaymentDetail()">
          <lucide-icon name="X" [size]="19" aria-hidden="true" />
        </button>
      </div>

      <div class="max-h-[68vh] overflow-y-auto p-5 sm:p-6">
        <section>
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูล Booking</h3>
          <dl class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3">
            <div><dt class="text-xs font-semibold text-slate-500">เลขที่ Booking</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.bookingCode }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">ลูกค้า</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.customerName }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">โปรแกรมทัวร์</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.tripName }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.travelDate | date: 'dd MMM yyyy' }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">จำนวนผู้เดินทาง</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.travelerCount | number }} คน</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">ยอด Booking</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.bookingTotal | number: '1.2-2' }} บาท</dd></div>
          </dl>
        </section>

        <section class="mt-6">
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลการชำระเงิน</h3>
          <dl class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3">
            <div><dt class="text-xs font-semibold text-slate-500">ชื่อผู้ชำระเงิน</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.payerName }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">ประเภทการชำระ</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.paymentType }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">จำนวนเงิน</dt><dd class="mt-1 mb-0 font-semibold text-emerald-700">{{ payment.amount | number: '1.2-2' }} บาท</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">วันที่ชำระ</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.paidAt | date: 'dd MMM yyyy' }}</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">เวลา</dt><dd class="mt-1 mb-0 font-semibold text-slate-800">{{ payment.paidTime }} น.</dd></div>
            <div><dt class="text-xs font-semibold text-slate-500">ไฟล์สลิป</dt><dd class="mt-1 mb-0 break-all font-semibold text-sky-700">{{ payment.slipFileName }}</dd></div>
          </dl>
        </section>

        <section class="mt-6">
          <h3 class="m-0 text-base font-bold text-slate-800">เอกสารประกอบ</h3>
          <div class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2">
            <label class="grid gap-1.5 text-sm font-semibold text-slate-700">
              <span>ลิงก์ใบเสร็จ</span>
              <input
                type="url"
                pInputText class="h-11 w-full font-normal"
                [(ngModel)]="payment.receiptUrl"
                placeholder="https://example.com/receipt"
              />
            </label>
            <label class="grid gap-1.5 text-sm font-semibold text-slate-700">
              <span>ลิงก์ใบเสนอราคา</span>
              <input
                type="url"
                pInputText class="h-11 w-full font-normal"
                [(ngModel)]="payment.quotationUrl"
                placeholder="https://example.com/quotation"
              />
            </label>
          </div>
        </section>
      </div>

      <div class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6">
        <button type="button" class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100" (click)="closePaymentDetail()">ปิด</button>
        @if (payment.status === 'WAITING_VERIFY') {
          <button type="button" class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-red-200 bg-white px-5 text-[15px] font-semibold text-red-600 hover:bg-red-50" (click)="rejectPayment(payment)">
            <lucide-icon name="X" [size]="17" aria-hidden="true" /> ไม่อนุมัติ
          </button>
          <button type="button" class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-5 text-[15px] font-semibold text-white hover:bg-emerald-700" (click)="approvePayment(payment)">
            <lucide-icon name="Check" [size]="17" aria-hidden="true" /> อนุมัติ
          </button>
        }
      </div>
    </section>
  </div>
}
